export default function usageReportEndpointConverter({ data }) {
  return {
    usage: data.attributes.usage,
    totalUsage: data.attributes['total-usage'],
    householdUsageProportion: data.attributes['household-usage-proportion'],
    tenancyUsageProportion: data.attributes['tenancy-usage-proportion'],
  }
}
